import { render, staticRenderFns } from "./ExcursionScope.vue?vue&type=template&id=ca5ef128&scoped=true"
import script from "./ExcursionScope.vue?vue&type=script&lang=ts"
export * from "./ExcursionScope.vue?vue&type=script&lang=ts"
import style0 from "./ExcursionScope.vue?vue&type=style&index=0&id=ca5ef128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5ef128",
  null
  
)

export default component.exports